import isArray from 'lodash/isArray';
import mergeWith from 'lodash/mergeWith';
import type { VersionId } from '../../../common/model';
import { MOVE } from '../../model/operation';
import { FIXED_IN, AFFECTS } from '../../model/system-field';
import type { FieldOperation, Field } from '../../model/types';
import type { SwapVersionsPayload } from '../../rest/delete/types';

const mapFieldToKey = (field: Field, targetVersion?: VersionId) => {
	if (field.id === FIXED_IN.id) {
		return { moveFixIssuesTo: targetVersion };
	}
	if (field.id === AFFECTS.id) {
		return { moveAffectedIssuesTo: targetVersion };
	}
	return {
		customFieldReplacementList: [
			{
				customFieldId: field.id,
				moveTo: targetVersion,
			},
		],
	};
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const customizer = (objValue: any, srcValue: any) => {
	if (isArray(objValue)) {
		return objValue.concat(srcValue);
	}
	return undefined;
};

export const transformSwapConfiguration = (configuration: FieldOperation[]): SwapVersionsPayload =>
	mergeWith(
		{},
		...configuration.map(({ operation, relatedField, targetVersion }) =>
			operation === MOVE && targetVersion ? mapFieldToKey(relatedField.field, targetVersion) : {},
		),
		customizer,
	);
